import { ONLINE_COURSE, PRENATAL_YOGA } from "./courseTypes";

export function getOfferingListingPath(listingType) {
  return listingType === PRENATAL_YOGA ? "/prenatal-yoga" : "/online-courses";
}

export function getInstructorDetailPath(listingType, instructorSlug) {
  if (!instructorSlug) return null;
  return `${getOfferingListingPath(listingType)}/instructor/${instructorSlug}`;
}

export function getProviderDetailPath(listingType, providerSource) {
  if (!providerSource) return null;
  const slug = encodeURIComponent(String(providerSource).trim().toLowerCase());
  return `${getOfferingListingPath(listingType)}/provider/${slug}`;
}

export function getItemDetailPath(item) {
  if (item?.is_school_group && item?.provider_source) {
    return getProviderDetailPath(item.type || item.listing_type, item.provider_source);
  }
  if (item?.is_teacher_group && item?.instructor_slug) {
    return getInstructorDetailPath(item.type || item.listing_type, item.instructor_slug);
  }
  if (item?.item_source === "teacher_offering" && item?.slug) {
    const base = getOfferingListingPath(item.type || item.listing_type);
    return `${base}/${item.slug}`;
  }
  if (item?.slug && (item.type === ONLINE_COURSE || item.type === PRENATAL_YOGA)) {
    return `/retreats/${item.slug}`;
  }
  return null;
}
